const SAMPLE_GROUP_STORAGE_KEY = 'sampleGroup';
const SAMPLE_GROUP_QUERY_PARAM = 'sg';

const isValidSampleGroup = (sampleGroup: string): boolean =>
  /^\d{1,2}$/.test(sampleGroup) &&
  parseInt(sampleGroup, 10) >= 0 &&
  parseInt(sampleGroup, 10) <= 30;

export const generateSampleGroup: () => string = () => {
  const sampleGroupFromLocalStorage: string | null = localStorage.getItem(SAMPLE_GROUP_STORAGE_KEY);
  const sampleGroupFromQuery: string | null = new URLSearchParams(window.location.search).get(
    SAMPLE_GROUP_QUERY_PARAM,
  );
  const prevSampleGroup = sampleGroupFromLocalStorage || sampleGroupFromQuery;
  if (prevSampleGroup && isValidSampleGroup(prevSampleGroup)) {
    localStorage.setItem(SAMPLE_GROUP_STORAGE_KEY, prevSampleGroup);
    return prevSampleGroup;
  }

  const newSampleGroup: string = Math.floor(Math.random() * 30).toString();
  localStorage.setItem(SAMPLE_GROUP_STORAGE_KEY, newSampleGroup);
  return newSampleGroup;
};
